export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10349.ba386085.jpg";